import * as React from 'react';

export const MerchCredits = () => (
  <svg
    id="MerchCredit_svg__Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    x={0}
    y={0}
    viewBox="0 0 40 26"
    xmlSpace="preserve"
    aria-hidden
    data-testid="merchcredits-logo"
  >
    <style>
      {
        '.MerchCredit_svg__st0{fill:#2da8df}.MerchCredit_svg__st2{fill:#016197}.MerchCredit_svg__st4{fill:#38454f}'
      }
    </style>
    <path
      className="MerchCredit_svg__st0"
      d="M36.4 0H2.8c-.2 0-.5 0-.7.1-.3 0-.5.1-.7.2C1.1.4.9.6.7.8c-.1.1-.3.4-.4.6-.1.2-.2.5-.2.7-.1.3-.1.5-.1.8V23.1c0 .3 0 .5.1.8 0 .3.1.5.2.7.1.2.3.4.4.6.2.2.4.3.6.4.2.1.5.2.7.2.3.2.6.2.8.2H37c.3 0 .5 0 .8-.1.3 0 .5-.1.7-.2.2-.1.4-.3.6-.4.2-.2.3-.4.4-.6.1-.2.2-.5.2-.7 0-.3.1-.5.1-.8v-.4V3.6v-.4-.4c0-.3 0-.5-.1-.8 0-.3-.1-.5-.2-.7-.1-.2-.3-.4-.4-.6-.2-.2-.4-.3-.6-.4-.2-.1-.5-.2-.7-.2-.1-.1-.4-.1-.6-.1h-.8z"
    />
    <path
      d="M36.4.9h.7c.2 0 .4 0 .6.1.3 0 .4 0 .6.1.1.1.3.2.4.3.1.1.2.3.3.4.1.1.1.3.2.5 0 .2 0 .4.1.6V23c0 .2 0 .4-.1.6 0 .2-.1.3-.2.5-.1.1-.2.3-.3.4-.1.1-.2.2-.4.3-.2.2-.3.2-.5.3-.2 0-.4 0-.6.1H2.9c-.2 0-.4 0-.6-.1-.3-.1-.4-.1-.6-.2-.1-.1-.3-.2-.4-.3-.1-.1-.2-.3-.3-.4-.1-.1-.1-.3-.2-.5 0-.2 0-.4-.1-.6V3.2v-.3c0-.2 0-.4.1-.6 0-.2.1-.3.2-.5.1-.1.2-.3.3-.4.1-.1.2-.2.4-.3.2-.1.3-.1.5-.2.2 0 .4 0 .6-.1h33.6"
      fill="#d4eef7"
    />
    <path className="MerchCredit_svg__st2" d="M20 22.3l4.6-8h-9.2z" />
    <path className="MerchCredit_svg__st0" d="M15.4 14.3h9.2l-4.6-8z" />
    <path fill="#6ecef4" d="M18.7 4.1H9.5l5.9 10.2 4.6-8z" />
    <path
      className="MerchCredit_svg__st2"
      d="M21.3 4.1L20 6.3l4.6 8 5.9-10.2z"
    />
    <g>
      <path
        className="MerchCredit_svg__st4"
        d="M24.2 21h-.5v1.3h-.2V21H23v-.2h1.2v.2zM26.2 22.3H26V21l-.4 1.1h-.3l-.5-1.1v1.2h-.2v-1.5h.4l.4 1.1.4-1.1h.4v1.6z"
      />
    </g>
  </svg>
);
